<template>
    <div>
        <el-table :data="contractLogList" border style="width: 100%">
            <el-table-column prop="merchantName" label="商户名称" align="left"></el-table-column>
            <el-table-column prop="comName" label="公司名称" align="left"></el-table-column>
            <el-table-column prop="userName" label="操作人" width="220" align="left"></el-table-column>
            <el-table-column prop="action" label="动作" width="120" align="left"></el-table-column>
            <el-table-column prop="ts" label="时间戳" width="180" align="center"></el-table-column>
            <el-table-column label="操作" width="100" align="left">
                <template slot-scope="rows">
                    <a class="swb-btn-link" @click="showDetails(rows.row.id)">详情</a>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { Utils} from '../../app.base'
    import { Vue, MsgBox, Routes  } from '../../app.vues'

    import contractApi from '../../api/contract'

    import SwbContractLogInfo from './ContractLogInfo';
    Vue.regist(SwbContractLogInfo);

    export default {
        name: 'swb-contract-log-list',
        desc: '合同日志列表',
        props: ['contractNo'],
        data: function () {
            return {
                contractLogList: [],
            }
        },
        created: function () {
            this.getContractLogList();
        },
        methods: {
            getContractLogList: function () {
                let self = this;
                let postData = {};
                postData.contractNo = this.contractNo;
                contractApi.getContractLogListByContractNo(postData, function (result) {
                    if(result.type === 'info') {
                        //
                        self.contractLogList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 详情
            showDetails: function (contractLogId) {
                Vue.$showDialog({
                    title: '合同日志详情',
                    width: '60%',
                    height: 600,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-contract-log-info :contractLogId="contractLogId" ref="swb_contract_log_info"></swb-contract-log-info>' +
                    '</div>',
                    data: {
                        contractLogId: contractLogId
                    },
                    methods: {},
                    okClicked: function () {
                    },
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractLogList.vue